function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React, { useContext } from "react";
import PropTypes from "prop-types";
import { omit } from "lodash-es";
import { Close } from "../../icons";
import { Context } from "./Modal";
import { onEnter } from "../../helpers";
const ModalHeader = props => {
  const context = useContext(Context);
  return /*#__PURE__*/React.createElement("div", _extends({}, omit(props, "closeButton"), {
    className: `tui-modal-header ${props.className}`,
    style: props.style
  }), props.children, props.closeButton && /*#__PURE__*/React.createElement("span", {
    className: "close-button",
    tabIndex: "0",
    role: "button",
    onClick: context.onCancel,
    onKeyPress: onEnter(context.onCancel)
  }, /*#__PURE__*/React.createElement(Close, {
    tabIndex: "-1"
  })));
};
ModalHeader.displayName = "ModalHeader";
ModalHeader.defaultProps = {
  style: {},
  className: "",
  closeButton: false,
  children: "Modal Title"
};
ModalHeader.propTypes = {
  style: PropTypes.object,
  className: PropTypes.string,
  closeButton: PropTypes.bool,
  children: PropTypes.node
};
export default ModalHeader;
//# sourceMappingURL=ModalHeader.js.map